<template>
    <page>
        <v-container fluid grid-list-md>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-expansion-panels v-model="panel1" multiple>
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                <div>
                                    <v-icon>mdi-filter-variant</v-icon> Filters
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-card>
                                    <v-card-text>
                                        <v-layout row wrap>
                                        <v-flex xs12 sm6>
                                            <cal-picker v-model="form.uwTranDateFrom" :label="labels.UWtranDateFrom"
                                                :data-vv-as="labels.UWtranDateFrom" data-vv-name="form.uwTranDateFrom"
                                                :error-messages="errors.collect('form.uwTranDateFrom')"
                                                v-validate="'required'" />
                                            </v-flex>
                                            <v-flex xs12 sm6>
                                            <cal-picker v-model="form.uwTranDateTo" :label="labels.UWtranDateTo"
                                                :data-vv-as="labels.UWtranDateTo" data-vv-name="form.uwTranDateTo"
                                                :error-messages="errors.collect('form.uwTranDateTo')"
                                                v-validate="'required'" />
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap>
                                        <v-flex xs12 sm6>
                                            <cal-picker v-model="form.ytdTransDateFrom" :label="labels.YTDTransDateFrom"
                                                :data-vv-as="labels.YTDTransDateFrom" data-vv-name="form.ytdTransDateFrom"
                                                :error-messages="errors.collect('form.ytdTransDateFrom')"
                                                v-validate="'required'" />
                                            </v-flex>
                                            <v-flex xs12 sm6>
                                            <cal-picker v-model="form.ytdTransDateTo" :label="labels.YTDTransDateTo"
                                                :data-vv-as="labels.YTDTransDateTo" data-vv-name="form.ytdTransDateTo"
                                                :error-messages="errors.collect('form.ytdTransDateTo')"
                                                v-validate="'required'" />
                                            </v-flex>
                                          </v-layout>
                                          <v-flex xs12 sm6>
                                            <cal-picker v-model="form.lastYearOSClmAt" :label="labels.lastYearOSClmAt"
                                                :data-vv-as="labels.lastYearOSClmAt" data-vv-name="form.lastYearOSClmAt"
                                                :error-messages="errors.collect('form.lastYearOSClmAt')"
                                                v-validate="'required'" />
                                          </v-flex>
                                          <v-flex xs12 sm6>
                                            <v-text-field v-model="form.interType" :label="labels.interType" :error-messages="errors.collect('form.interType')" :data-vv-as="labels.interType" v-validate="'required'"
                                            data-vv-name="form.interType" append-icon="mdi-magnify" @click:append="getHelpList('interType')" readonly/>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-text-field v-model="form.acctNo" :label="labels.acctNo" :error-messages="errors.collect('form.acctNo')" :data-vv-as="labels.acctNo" v-validate="'required'"
                                            data-vv-name="form.acctNo" append-icon="mdi-magnify" @click:append="getHelpList('acctNo')" readonly/>
                                        </v-flex>
                                        </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-flex>
            </v-layout>
        </v-container>
        <v-flex xs12>
          <v-expansion-panels v-model="panel4" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Report Setting</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-checkbox
                      :label="labels.pbPrtParam"
                      v-model="form.pbPrtParam"
                      :error-messages="errors.collect('pbPrtParam')"
                      data-vv-name="pbPrtParam"
                      :data-vv-as="labels.pbPrtParam"
                    />
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 class="pt-3">
                <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doExport">
                  <v-icon left dark>mdi-file-export</v-icon>
                  {{ labels.export }}
                </v-btn>
                <v-btn-toggle dense mandatory v-model="form.format">
                  <v-btn flat v-for="format in supportedList" :key="format.value" :value="format.value">
                    <span>{{ format.label }}</span>
                    <v-icon :color="format.color">{{ format.icon }}</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-flex>
            </v-layout>
          </v-container>
        <v-dialog v-model="multiInterType" width="900px" persistent>
          <intermediary-type-help-list2
            :intr="form.interType"
            helpListTitle="Intermediary Type HelpList"
            @close="doClose" @doAssign="doAssignInterType($event)"></intermediary-type-help-list2>
        </v-dialog>
        <v-dialog v-model="multiInterList" width="900px" persistent>
          <multi-intermediary-help-list
            :intr="form.acctNo"
            :intrGrp="form.interType"
            :refresh="multiInterList"
            listName="intermediaries"
            helpListTitle="Account No HelpList"
            @close="doClose" @doAssign="doAssignInter($event)"></multi-intermediary-help-list>
        </v-dialog>
    </page>
</template>
<script>
import MessageMixin from '@/mixins/message'
import MultiIntermediaryHelpList from '@/components/core/common/dialog/MultiIntermediaryHelpList.vue'
import IntermediaryTypeHelpList2 from '../../../core/common/dialog/IntermediaryTypeHelpList2.vue'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
export default {
  mixins: [
    MessageMixin
  ],
  data() {
    return {
      menu: {},
      form: {
        uwTranDateFrom: new Date(),
        uwTranDateTo: new Date(),
        ytdTransDateFrom: new Date(),
        ytdTransDateTo: new Date(),
        lastYearOSClmAt: new Date(),
        interType: 'All',
        acctNo: 'All',
        format: 'PDF',
        pbPrtParam: true
      },
      labels: {
        UWtranDateFrom: 'Underwriting Trans Date From',
        UWtranDateTo: 'Underwriting Trans Date To',
        YTDTransDateFrom: 'YTD Claims Payt Trans Date From',
        YTDTransDateTo: 'YTD Claims Payt Trans Date To',
        lastYearOSClmAt: 'Last Year O/s Claims As At',
        interType: 'Intermediary Type(s)',
        acctNo: 'Account No(s)',
        export: 'Export To',
        pbPrtParam: 'Print Run Time Parameters'
      },
      panel1: [0],
      multiInterList: false,
      multiInterType: false,
      supportedFormat: [],
      loading: false
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.riReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.riReports.menu !== 1) {
          await this.$store.dispatch('riReportsInit')
        }
        const apiURI = this.rptMenu.initRIGrossPremStats
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result
          if (data) {
            this.supportedFormat = data.data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiUrl = this.menu.export
      if (apiUrl) {
        try {
          this.loading = true
          await this.$http.post(apiUrl, this.form)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url. [processExport]')
      }
      this.loading = false
    },
    getHelpList(field) {
      switch (field) {
        case 'interType':
          this.multiInterType = true
          break
        case 'acctNo':
          this.multiInterList = true
          break
      }
    },
    doClose() {
      this.multiInterList = false
      this.multiInterType = false
    },
    async doAssignInter(Obj) {
      this.form.acctNo = []
      this.form.acctNo = Obj.finalSelectedItems.toString()
    },
    async doAssignInterType(Obj) {
      this.form.interType = []
      this.form.interType = Obj.finalSelectedItems.toString()
    }
  },
  created() {
    this.doInit()
  },
  components: {
    MultiIntermediaryHelpList,
    IntermediaryTypeHelpList2
  }
}
</script>
